// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_offset_backing/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_offset_backing: ModuleSchema = {
  "id": "core_offset_backing",
  "uniqueId": "B3D_OFF01",
  "createdAt": "2026-10-14T19:00:00Z",
  "updatedAt": "2026-10-14T12:00:41.011Z",
  "label": "Offset Backing",
  "description": "Builds a rounded printable backing from detail silhouettes (CG_OFF01).",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_OFF01",
    "offset",
    "backing"
  ],
  "sliders": [
    {
      "key": "detailWidth",
      "label": "Detail Width (mm)",
      "min": 4,
      "max": 100,
      "default": 24,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "detailHeight",
      "label": "Detail Height (mm)",
      "min": 4,
      "max": 100,
      "default": 18,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "cornerRadius",
      "label": "Detail Corner Radius (mm)",
      "min": 0,
      "max": 30,
      "default": 3,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "offset",
      "label": "Backing Offset (mm)",
      "min": 0,
      "max": 10,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "depth",
      "label": "Base Depth (mm)",
      "min": 0.1,
      "max": 30,
      "default": 8,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "reliefDepth",
      "label": "Relief Depth (mm)",
      "min": 0.1,
      "max": 10,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Backing",
      "default": "#DB2777",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "detail",
      "label": "Detail",
      "default": "#F3E8FF",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
